import React from "react";
import { ThemeProvider } from "@material-ui/core/styles";
import Content from "../../Molecules/Content";
import { jsx as _jsx } from "react/jsx-runtime";
export var PropertyDetail = function PropertyDetail(_ref) {
  var propertyBackgroundColorWithOverlay = _ref.propertyBackgroundColorWithOverlay,
    addHeader = _ref.addHeader,
    headerClass = _ref.headerClass,
    config = _ref.config,
    winnreNoAuth = _ref.winnreNoAuth,
    winnreAuth = _ref.winnreAuth,
    location = _ref.location,
    isAuthenticated = _ref.isAuthenticated,
    userRole = _ref.userRole,
    history = _ref.history,
    Modal = _ref.Modal,
    VideoModal = _ref.VideoModal,
    auth = _ref.auth,
    DetailProjectLoadingUI = _ref.DetailProjectLoadingUI,
    LoadingSpinner = _ref.LoadingSpinner,
    scrollToTargetAdjusted = _ref.scrollToTargetAdjusted,
    copyCodeHandler = _ref.copyCodeHandler,
    theme = _ref.theme,
    appType = _ref.appType,
    _ref$amenitiesLabel = _ref.amenitiesLabel,
    amenitiesLabel = _ref$amenitiesLabel === void 0 ? "Amenities" : _ref$amenitiesLabel;
  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: theme,
    children: /*#__PURE__*/_jsx(Content, {
      propertyBackgroundColorWithOverlay: propertyBackgroundColorWithOverlay,
      headerClass: {
        addHeader: addHeader,
        headerClass: headerClass
      },
      config: config,
      winnreNoAuth: winnreNoAuth,
      winnreAuth: winnreAuth,
      isAuthenticated: isAuthenticated,
      auth: auth,
      userRole: userRole,
      location: location,
      history: history,
      Modal: Modal,
      VideoModal: VideoModal,
      DetailProjectLoadingUI: DetailProjectLoadingUI,
      LoadingSpinner: LoadingSpinner,
      scrollToTargetAdjusted: scrollToTargetAdjusted,
      copyCodeHandler: copyCodeHandler,
      appType: appType,
      amenitiesLabel: amenitiesLabel
    })
  });
};
export default PropertyDetail;